import { notifyErrorWith } from "@/common/notify";
import { useCollection } from "@/api/hooks";
import { useSetCollectionVisibilityMutation } from "@/api/api";
import { Switch } from "../switch";
import { Field, FieldContent, FieldDescription, FieldLabel } from "../field";

export default function CollectionVisibility() {
  const collection = useCollection();
  const [setVisibility] = useSetCollectionVisibilityMutation();

  if (!collection) return null;

  // A provider collection holds no rows: its records are fetched in the
  // owner's browser with the owner's token, so a public one would be empty for
  // everyone who opened it. The server refuses this too -- the switch is
  // disabled so the refusal never has to be explained after the fact.
  const isProvider = !!collection.provider_key;

  const handleToggle = (isPublic: boolean) => {
    setVisibility({ collectionID: collection.id, isPublic })
      .unwrap()
      .catch(notifyErrorWith("Couldn't change who can see the collection"));
  };

  return (
    <Field orientation="horizontal">
      <FieldContent>
        <FieldLabel
          htmlFor="collectionVisibility"
          className="text-[13.5px] font-semibold"
        >
          Public
        </FieldLabel>
        <FieldDescription className="text-[12px]">
          {isProvider
            ? "Collections that mirror an external system stay private: only the account that authorized them can read their records"
            : "Anyone can view this collection"}
        </FieldDescription>
      </FieldContent>
      <Switch
        id="collectionVisibility"
        checked={collection.is_public}
        onCheckedChange={handleToggle}
        disabled={isProvider}
      />
    </Field>
  );
}
